<template>
    <div class="app-content">
        <div v-show="currentShowPage == 1">
            <div class="app-title mb10">
                <!-- 应用标题 -->
                <div class="app-titles">
                    <i :class="currentSelectMenuData.css" class="app-title-icon"></i>
                    <span class="app-title-main">{{currentSelectMenuData.name}}</span>
                </div>
                <!-- 列表按钮 -->
                <div class="app-buttons">
                    <el-button icon="icon-add" class="btn-green" size="mini" @click="addBtn">
                        <font>新建</font>
                    </el-button>
                    <el-button icon="icon-trash-2" class="btn-red" size="mini" @click="delBtn">
                        <font>删除</font>
                    </el-button>
                </div>
            </div>
            <!-- 列表高级搜索 -->
            <div>
                <el-row :gutter="20">
                    <el-form inline-message :model="searchList" label-width="100px">
                        <el-col :span="6">
                            <el-form-item label="用户名">
                                <el-input size="mini" v-model="searchList.username" @keyup.enter.native="searchBtn"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="姓名">
                                <el-input size="mini" v-model="searchList.nickname" @keyup.enter.native="searchBtn"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="机构名称">
                                <el-select size="mini" @change="selectdeptChange" clearable v-model="searchList.deptcode" filterable default-first-option placeholder="请选择" style="width: 90%;border-radius:none" @keyup.enter.native="searchBtn">
                                    <el-option v-for="(data,index) in selectData" :key="index" :value="data.code" :label="data.fullname"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" style="line-height:40px">
                            <el-button icon="icon-search" class="btn btn-blue" size="mini" type="primary" @click="searchBtn">搜索</el-button>
                            <el-button icon="icon-refresh" class="btn-blue" size="mini" @click="resetBtn">重置</el-button>
                        </el-col>
                    </el-form>
                </el-row>
            </div>
            <!-- 表格 -->
            <el-row class="relative" id="pageDiv">
            <el-col :span="5" class="lefttree" id="left">
            <div class="lefttreebg">
                <!-- <div class="left_tree_title clearfix">
                <div class="pull-left pr20" v-if="ismin">组织机构</div>
                </div> -->
                <div class="left_treebg" :style="{height: fullHeight1}">
                <div class="p15" v-if="ismin">
                    <el-tree node-key="id" ref="tree" class="filter-tree" highlight-current :indent="22" :render-content="renderContent" :props="resourceProps" :load="loadNode" @node-click="handleNodeClick" lazy></el-tree>
                </div>
                </div>
            </div>
            </el-col>
            <div id="middle"></div>
            <el-col :span="19" class="leftcont" id="right">
            <el-table class="app-table" ref="vtable" :data="tableData" row-key="id" stripe highlight-current-row :height="fullHeight" @selection-change="selectTableData" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.5)">
                <el-table-column type="selection" width="55" :reserve-selection="true">
                </el-table-column>
                <el-table-column prop="username" label="用户名" :show-overflow-tooltip="true">
                    <template slot-scope="props">
                        <span class="blue" title="点击查看详情" @click="viewBtn(props.row)">{{props.row.username}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="nickname" label="姓名" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column align="center" width="100" prop="roleName" label="角色" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column align="center" width="100" prop="sexName" label="性别" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column align="center" width="100" prop="deptName" label="机构" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column align="center" width="100" prop="phone" label="手机号" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column align="center" width="100" prop="worknumber" label="员工号" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column align="center" width="100" prop="user_active_date" label="用户有效期" :show-overflow-tooltip="true">
                </el-table-column>
            </el-table>
            <div class="pt10 text-right">
                <el-pagination @size-change="sizeChange" background @current-change="currentChange" :current-page="page.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="page.pageSize" layout="total, sizes, prev, pager, next" :total="page.totalCount">
                </el-pagination>
            </div>
            </el-col>
            </el-row>
        </div>
        <usermanagementdetail v-show="currentShowPage == 2"  ref="usermanagementdetail" @requestData="getData('reset')"></usermanagementdetail>
    </div>
</template>

<script>

import usermanagementdetail from "./user_managementdetail"
import $ from 'jquery'
export default {
    name:"user_management",
    components:{usermanagementdetail},
    data(){
        return{
            tableData:[],
            page: {
                currentPage: 1,
                pageSize: 20,
                totalCount: 0
            },
            fullHeight: document.documentElement.clientHeight - 235,//获取浏览器高度
            fullHeight1: document.documentElement.clientHeight - 235 + 'px',//获取浏览器高度
            loading:false,
            selectTableList:[],
            basic_url: Config.dev_url,//请求地址
            drawer:false,
            searchList:{},
            selectData: [],
            resourceData: [], //数组，我这里是通过接口获取数据，
            resourceProps: {
                children: "subDepts",
                label: "fullname"
            },
            ismin: true,
            deptdesc:''//当前选中机构描述
        }
    },
    directives:{
        drag:{
            bind:function(el){
                let odiv = el;
                odiv.onmousedown = (e) =>{
                    let disX = e.clientX - odiv.offsetLeft;
                    let disY = e.clientY - odiv.offsetTop;
                    document.onmousemove = (e) =>{
                        let left = e.clientX - disX;
                        let top = e.clientY - disY;
                        odiv.style.left = left + "px";
                        odiv.style.top = top + "px";
                    };
                    document.onmouseup = (e) =>{
                        document.onmousemove = null
                        document.onmouseup = null
                    }
                }
            }
        }
    },
    computed:{
        //当前左侧菜单选中的信息
        currentSelectMenuData(){
            return this.$store.state.currentSelectMenuData
        },
        //列表显示的按钮
        listButtons(){
            return this.$store.state.buttons
        },
        //当前登录人信息
        currentuser() {
            return this.$store.state.currentuser
        },
        currentShowPage(){
            return this.$store.state.currentShowPage
        },
    },
    methods:{
        // 查询下拉框change
        selectdeptChange(val){
            //传进来的val是select组件选中的value值，也就是一个fruitEnName
            var obj = {}
            obj = this.selectData.find(function(item){
                return item.code === val
            })
            this.deptdesc = obj.fullname;//当前选中机构的描述
        },
        // 左侧树
        async loadNode(node, resolve) {
            if (node.level === 0) {
                this.resourceData = await this.getKey();
                return resolve(this.resourceData);
            }
            if (node.level != 0) { // 二级节点
                this.getChildrenNode(node, resolve)
            }
        },
        getChildrenNode(node, resolve) {
            var nodeid = node.data.code;
            var url = Config.dev_url + '/api-user/depts/findByCodeTree/' + nodeid;
            this.$axios.get(url, {}).then((res) => {
                this.resourceData = res.data;
                if (res.data == null) {
                return resolve([]);
                this.$message.error(res.data.resp_msg);
                return;
                }
                resolve(this.resourceData);
                this.transformTree(this.resourceData);
            }).catch((err) => {
                });
        },
        renderContent(h, { node, data, store }) { //自定义Element树菜单显示图标
            return (<span><i class={data.iconClass}></i><span>{node.label}</span></span>)
        },
        // 点击节点
        nodeClick: function (m) {
            if (m.iconClass != 'icon-file-text') {
                if (m.iconClass == 'icon-file-normal') {
                m.iconClass = 'icon-file-open';
                } else {
                m.iconClass = 'icon-file-normal';
                }
            }
        },
        expandClick: function (m) {
        if (m.iconClass != 'icon-file-text') {
            if (m.iconClass == 'icon-file-normal') {
            m.iconClass = 'icon-file-open';
            } else {
            m.iconClass = 'icon-file-normal';
            }
        }
        m.isFolder = !m.isFolder;
        },
        getKey() {
            let that = this;
            return new Promise(function (resolve, reject) {
                var url = that.basic_url + '/api-user/depts/firstTree';
                that.$axios.get(url, {}).then((res) => {
                resolve(res.data);
                that.resourceData = res.data;
                that.transformTree(that.resourceData);
                }).catch((err) => {
                });
            })
        },
        transformTree(data) {
            for (var i = 0; i < data.length; i++) {
                data[i].name = data[i].fullname;
                if (!data[i].pid || $.isArray(data[i].subDepts)) {
                    data[i].iconClass = 'icon-file-normal';
                } else {
                    data[i].iconClass = 'icon-file-text';
                }
                if ($.isArray(data[i].subDepts)) {
                    data[i].children = this.transformTree(data[i].subDepts);
                }
            }
            return data;
        },
        handleNodeClick(data) {
            this.searchList.deptcode = data.code;
            this.deptdesc = data.fullname;
            this.searchData();
        },
        //删除高级搜索显示的某个tag
        closeSearchTagBtn(val){
            this.searchList[val] = ""
            if(!this.searchList.username && !this.searchList.nickname&& !this.searchList.deptdesc){
                this.getData();
            }else{
                this.searchData()
            }
        },
        //主表列表高级搜索
        searchBtn() {
            this.drawer = false
            this.searchData()
        },
        //主表列表重置按钮
        resetBtn() {
            this.searchList = {}
            this.drawer = false
            this.getData()
        },
        //查看数据详情
        viewBtn(item){
            this.$store.commit('setcurrentShowPage',2)
            this.$refs.usermanagementdetail.view(item)
        },
        //新建按钮
        addBtn(){
            this.$store.commit('setcurrentShowPage',2)
            this.$refs.usermanagementdetail.addBtn()
        },
        delBtn(){
            if(this.selectTableList.length == 0){
                this.$message.warning("请选择要删除的数据")
                return
            }else if(this.selectTableList.length > 1){
                this.$message.warning("不可以同时删除多个数据")
                return
            }
            this.$confirm("确定删除此数据吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消"
            }).then(({ value }) => {
                var url = Config.dev_url + '/api-user/users/physicsDel';
                var data = {
                    ids: this.selectTableList[0].worknumber,
                }

                this.$axios.delete(url, {
                    params: data
                }).then((res) => { //.delete 传数据方法
                    if (res.data.code == 0) {
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.getData('reset');
                    }else{
                        this.$message.warning(res.data.msg)
                    }
                }).catch((err) => {
                });
            })
        },
        //选中表格某条数据时触发
        selectTableData(val) {
            this.selectTableList = val
        },
        //高级搜索
        searchData(){
            var data = {
                username: this.searchList.username,
                nickname: this.searchList.nickname,
                deptcode: this.searchList.deptcode,
                page: this.page.currentPage,
                limit: this.page.pageSize
            }

            var url = Config.dev_url + '/api-user/users';
            this.$axios.get(url,{ params: data}).then((res)=>{
                this.loading = false
                this.tableData = res.data.data
                this.page.totalCount = res.data.count;
            }).catch((err) => {
                });
        },
        //机构值
        getCompany() {
            var type = "2";
            var url = Config.dev_url + '/api-user/depts/getAllDepts';
            this.$axios.get(url, {
                params: {
                type: type
                },
            }).then((res) => {
                this.selectData = res.data;
            });
        },
        sizeChange(val) {
            this.page.pageSize = val;
            this.searchData();
        },
        currentChange(val) {
            this.page.currentPage = val;
            this.searchData();
        },
        //获取数据
        getData(str){
            if(str == 'reset'){
                this.tableData = []
            }
            this.page.currentPage = 1;
            this.page.pageSize = 20;
            var data = {
                page:1,
                limit:20
            };
            var url = Config.dev_url + '/api-user/users';
            this.$axios.get(url,{ params: data}).then((res)=>{
                // this.$nextTick(() => {
                    this.$refs.vtable.clearSelection()
                // });
                this.loading = false
                this.tableData = res.data.data
                this.page.totalCount = res.data.count;
            }).catch((err) => {
                });
        },
        //树和表单之间拖拽改变宽度
        treeDrag() {
        var middleWidth = 5,
            left = document.getElementById("left"),
            right = document.getElementById("right"),
            middle = document.getElementById("middle");
            middle.style.left = left.clientWidth + 'px';
            right.style.left = left.clientWidth + 5 + 'px';
            middle.onmousedown = function (e) {
            var disX = (e || event).clientX;
            middle.left = middle.offsetLeft;
            document.onmousemove = function (e) {
            var iT = middle.left + ((e || event).clientX - disX);
            var e = e || window.event, tarnameb = e.target || e.srcElement;
            var maxT = document.body.clientWidth;
            iT < 0 && (iT = 0);
            iT > maxT / 2 && (iT = maxT / 2);
            middle.style.left = left.style.width = iT + "px";
            right.style.width = maxT - iT - middleWidth - 230 + "px";
            right.style.left = iT + middleWidth + "px";
            return false
            };
            document.onmouseup = function () {
            document.onmousemove = null;
            document.onmouseup = null;
            middle.releaseCapture && middle.releaseCapture()
            };
            middle.setCapture && middle.setCapture();
            return false
        };
        }
    },
    mounted(){
        this.$store.commit('setcurrentShowPage',1)
        this.getData();
        this.getCompany();
        this.treeDrag();//调用树和表单之间拖拽改变宽度
    }
}
</script>

<style>

</style>
